import styled from 'styled-components'
import { AiImageGenerateOption } from '../styled'
import { CharacterCountIndicator, TextAreaInput } from 'common-components'
import { setCommonBorderStyles } from 'styles/mixins'
import { IMG_PROMPT_HEIGHT } from './consts'

export const AiImageGenerationPrompt = styled(AiImageGenerateOption)`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const AiImagePromptArea = styled.div<{
  $isFocusing: boolean
  $isError: boolean
  $isWarning: boolean
}>`
  position: relative;
  width: 100%;
  height: ${IMG_PROMPT_HEIGHT}px;
  border-radius: 4px;

  ${({ $isError, $isWarning, $isFocusing }) =>
    setCommonBorderStyles($isError, $isWarning, $isFocusing)};

  transition:
    border-color 0.3s,
    box-shadow 0.3s;
`

export const AiImageGenerationPromptTextArea = styled(TextAreaInput)`
  width: 100%;
`

export const CharacterCountIndicatorWrapper = styled(CharacterCountIndicator)`
  margin-top: 0px;
`
